import React, { useRef, useState, useEffect } from "react";
import playButton from "../../assets/img/play-button-white.svg";
import one from "../../assets/img/close-btn.svg";
const SimpleVideoPlayer = ({ src, imageSrc, title }) => {
  const [open, setOpen] = useState(false);
  const modalRef = useRef(null);

  const handleOutsideClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [open]);
  return (
    <>
      <div
        className="positon-relative"
        style={{
          position: "relative",
          height: "100%",
          padding: "10px",
        }}
      >
        <div style={{ position: "relative" }}>
          <img
            src={imageSrc}
            className="w-100 h-100 object-fit-cover"
            alt="thumbnail image"
            style={{
              borderRadius: "10px",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80px",
              height: "80px",
            }}
          >
            <button
              onClick={() => setOpen(true)}
              style={{
                display: "block",
                border: "none",
                cursor: "pointer",
                background: "none",
              }}
            >
              <img
                src={playButton}
                style={{ width: "100%", height: "100%" }}
                alt="play button"
              />
            </button>
          </div>
        </div>
        <p className="mt-2 text-yellow text-center">{title}</p>
      </div>

      {open && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            backdropFilter: "blur(3px)",
            WebkitBackdropFilter: "blur(3px)", // Fix for Safari
            zIndex: "10001",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px 15px",
          }}
        >
          <div
            style={{
              minHeight: "350px",
              maxWidth: "700px",
              width: "100%",
              position: "relative",
              // overflow: "hidden", // Prevents iframe clipping
            }}
            ref={modalRef}
          >
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                position: "absolute",
                top: "-65px",
                left: "0px",
                fontSize: "20px",
                width: "50px",
                height: "50px",
                cursor: "pointer",
                zIndex: 10002,
                backgroundColor: "#fff",
                borderRadius: "50%",
                padding: "10px",
              }}
              onClick={() => setOpen(false)}
            >
              <img src={one} className="w-100 h-100" alt="close" />
            </div>
            <iframe
              src={src}
              title={title}
              sandbox="allow-scripts allow-same-origin"
              allowTransparency="true" // Improves rendering on Safari
              allowFullScreen
              style={{
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                border: "none", // Removes unwanted borders
              }}
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default SimpleVideoPlayer;
